import { AxiosResponse } from 'axios';
import { defaultTo, map, path, pipe } from 'ramda';

import { DutyHourType, DutyHourTypesDto } from '../types';

import { dutyHourTypeConverter } from './dutyHourTypeConverter';

export const getDutyHourTypesTableDataConverter = pipe<
  [AxiosResponse<DutyHourTypesDto>],
  DutyHourTypesDto | undefined,
  DutyHourTypesDto,
  DutyHourType[]
>(path(['data']), defaultTo([]), map(dutyHourTypeConverter));
